import { Link } from '@com-delta-idp/mnx-ui-kit';
import { AnalyticsEvent } from '@com-delta-idp/mnx-utils';

export interface MedallionItem {
  medallionId: string;
  medallionLabel: string;
  medallionBenefitMessage: string;
  medallionBenefitUrl: string;
  medallionBenefit360Message: string;
  medallionBenefit360Url: string;
  openMedallionBenefitUrlNewTab: boolean;
}

export interface MemberBanner {
  medallion: MedallionItem[];
}

export interface SalutationItem {
  salutationId: string;
  salutationLabel: string;
}

export interface Salutation {
  salutation?: SalutationItem[];
}

export interface MedallionAriaLabel {
  skyPriorityLabel: string;
  millionMiler: string;
  level: string;
}

export interface MedallionBannerDetails {
  accountNumberLabel: string;
  analyticsEvent: AnalyticsEvent;
  ariaLabel: MedallionAriaLabel;
  availableMilesLabel: string;
  label360: string;
  medallionDetails: MemberBanner;
  millionMilerLabel: string;
  priority: Link;
  salutationCards: Salutation;
  showDurationLabel: string;
  statusLabel: string;
  trademark: string;
}

export interface AEMMedallionBannerContent {
  medallionBanner: MedallionBannerDetails;
}
